import { render, staticRenderFns } from "./FileImportStatus.vue?vue&type=template&id=2f8182d2&scoped=true&"
import script from "./FileImportStatus.vue?vue&type=script&lang=js&"
export * from "./FileImportStatus.vue?vue&type=script&lang=js&"
import style0 from "./FileImportStatus.vue?vue&type=style&index=0&id=2f8182d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8182d2",
  null
  
)

export default component.exports